import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  withAuthGatewayDiscovery,
  withBackstageAuth,
  withJsonContentType,
} from '@mercedes-benz/http-common';
import { JourneysSDK } from '@odp/journeys-sdk';

import { rootRouteRef } from './routes';
import { journeysApiRef } from './api';

export const journeysPlugin = createPlugin({
  id: 'journeys',
  apis: [
    createApiFactory({
      api: journeysApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        JourneysSDK.configure({
          // The discovery interceptor rewrites `baseURL` per request to
          // `${discoveryApi.getBaseUrl('auth-gateway')}/journeys`.
          baseURL: '',
        })
          .enablePlugin(withAuthGatewayDiscovery(discoveryApi, 'journeys'))
          .enablePlugin(withBackstageAuth(identityApi))
          .enablePlugin(withJsonContentType())
          .connect(),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const JourneysHomePage = journeysPlugin.provide(
  createRoutableExtension({
    name: 'JourneysPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
